import defaultColor from "@/components/color";

export default {
    attribute:{
        borderType:'dv-border-box-7',
        borderColor1:defaultColor[0],
        borderColor2:defaultColor[1],
        backgroundColor:'#00000000',
        borderTitle:'标题1',titleWidth:250,//样式11特殊配置
        dur:3, reverse:false,//样式8特殊配置
        colNum:2,
        rowNum:2,
        gridHeight:'regular',
        isPop:false,
        isCloseBtn:false,
        hasSubDataset:false,
        dataGroup:false,
        gridSpace:10,
        topSpace:20,
        bottomSpace:10,
        leftSpace:10,
        rightSpace:10,
        switchGrid:false,
        isCreatGridByData:false,
        isShowCheckBox:false,
        paginationFlag:false,
        paginationType:1,
        paginationMode:true,
        isScroll:false,
        xScroll:false,
        yScroll:false,
        isLock:false,
        checkFirst:false,
        checkColor: '',
        checkWidth: 0,
        cptIndex:1000000,
        pageNo:1,
        pageSize:5,
        reachBottom: 50,
        // 加载更多按钮配置
        btnWidth: 100,
        btnHeight: 30,
        btntop: 20,
        btnbottom: 20,
        isShowLoading: 0,
        isLoading: false,
        bgColor: defaultColor[0],
        textColor: '#ffffff',
        fontStyle: 'normal',
        fontWeight: 'normal',
        fontFamily: '微软雅黑',
        fontSize: 12,
        borderSize: 1,
        borderColor: '#333333',
        borderTopLeftRadius: 0,
        borderBottomLeftRadius: 0,
        borderTopRightRadius: 0,
        borderBottomRightRadius: 0,
        lineType: 'solid',
    },
    cptDataForm: {
        dataText: '[]',
        apiUrl: '/tab', 
        sql: 'select id from test limit 1',
        dataSource: 1, 
        cacheList: [], 
        cacheKey: '', 
        pollTime: -1,
        isCache: false,
    },
    interaction: { multi: false },
    compTabChildren: [[],[],[]],
    compTabIndex: 0,
    copyItems: [],

}

// export default {
//     attribute: {
//         textColor: '#65AFFE', fontSize: 18, lineHeight: 30, autoSwitch: false, interval: 3, xTabHeader: 0, yTabHeader: 0,
//         tabHeadWidth: 500, tabHeadHeight: 40, cptDragBorder: false
//     },
//     cptDataForm: {
//         dataText: '{"value":"op1","options":[{"label":"选项1","value":"op1"},{"label":"选项2","value":"op2"},{"label":"选项3","value":"op3"}]}',
//         apiUrl: '/tab', sql: 'select id from test limit 1',
//         dataSource: 1, pollTime: -1
//     },
//     interaction: { multi: true },
//     compTabChildren: [[],[],[]],
//     compTabIndex: 0,

// }